;(function() {
  // Define relevant parts of modal
  const modalSWrapper = document.getElementById('small-modal-wrapper');
  if (!modalWrapper) return;  
  const modalSBody = modalWrapper.querySelector('.small-modal-body');
  const closeSBtn = modalWrapper.querySelector('#small-modal-close-x');
  const closeSTxt = modalWrapper.querySelector('#small-modal-close-text');

  //Pass variable HTML content into modal container as a fn param
  function openSmallModal(content) {
    modalSBody.innerHTML = content;
    modalSWrapper.setAttribute('aria-hidden', 'false');
    modalSWrapper.classList.add('open');
    closeSBtn.focus();
    document.body.style.overflow = 'hidden';
  }

  function closeSmallModal() {
    modalSWrapper.setAttribute('aria-hidden', 'true');
    modalSWrapper.classList.remove('open');
    modalSBody.innerHTML = '';
    document.body.style.overflow = '';
  }

  //Define the above funcs globally to get around scope issues
  window.openSmallModal = openSmallModal;
  window.closeSmallModal = closeSmallModal;
  
  // When clicking modal closing elems (X btn, "Back to Page" txt, area outside modal), call closeModal
  closeSBtn.addEventListener('click', closeSmallModal);
  closeSTxt.addEventListener('click', closeSmallModal);
  modalSWrapper.addEventListener('click', e => {
    if (e.target === modalSWrapper) closeSmallModal();
  });
  
})();